import { useState } from 'react';
import classes from './AuctionDashMenu.module.scss';
import { ChevronDownIcon } from '@chakra-ui/icons';

const AuctionDashMenu = ({savedFilters,setFilter}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState("None");
  
    const toggleDropdown = () => {
      setIsOpen(!isOpen);
    };

    const handleOptionClick = (option) => {
        setSelectedOption(option);
        setFilter(option) 
        setIsOpen(false);
    };
  console.log('Saved Filters',savedFilters);
    return (
        <div className={classes.AuctionDashMenu}>
            <div className={classes.DropdownContainer}>
                <div className={classes.DropdownLabel} onClick={toggleDropdown}>
                Saved Search: <span className={classes.Highlighted}>{selectedOption}</span>
                <ChevronDownIcon
                        className={`${classes.Icon} ${
                        isOpen ? classes.ActiveIcon : ''
                    }`}/>
                </div>
        
                {isOpen && (
                <ul className={classes.DropdownMenu}>
                    <li key={"none"}
                                            onClick={() => handleOptionClick("None")}
                                            className={classes.DropdownItem}>None</li>
                    {savedFilters?.map((filter) => (
                    <li
                        key={filter.id}
                        onClick={() => handleOptionClick(filter.name)}
                        className={classes.DropdownItem}
                    >
                        {filter.name}
                    </li>
                    ))}
                </ul>
                )}
            </div>
        </div>
    );
}

export default AuctionDashMenu;